import Vue from 'vue'
import Vuex from 'vuex'
import bots from '@/store/modules/bots'
import botTemplates from '@/store/modules/botTemplates'
import socket from '@/store/modules/socket'
import identities from '@/store/modules/identities'
import workflows from '@/store/modules/workflows'
import apiAutomation from '@/store/modules/apiautomations'
import session from '@/store/modules/session'
import enums from '@/store/modules/enums'
import honeyRoles from '@/store/modules/honeyroles'
import kpis from '@/store/modules/kpis'
import execution from '@/store/modules/execution'
import rules from '@/store/modules/rules'
import hives from '@/store/modules/hives'
import personalAccessTokens from '@/store/modules/personalAccessTokens'
import profiles from '@/store/modules/profiles'
import tasks from '@/store/modules/tasks'
import selfServices from '@/store/modules/selfServices'
import honeyUsers from '@/store/modules/honeyUsers'
import automationRequests from '@/store/modules/automationRequests'
import honeyForms from '@/store/modules/honeyForms'
import emails from '@/store/modules/emails'
import theme from '@/store/modules/theme'
import camunda from '@/store/modules/camunda'
import jobs from '@/store/modules/jobs'
import admin from '@/store/modules/admin'
import emailTemplates from '@/store/modules/emailTemplate'
import packages from '@/store/modules/packages'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    session,
    bots,
    botTemplates,
    socket,
    identities,
    profiles,
    workflows,
    apiAutomation,
    enums,
    personalAccessTokens,
    honeyRoles,
    kpis,
    execution,
    rules,
    hives,
    tasks,
    selfServices,
    honeyUsers,
    honeyForms,
    automationRequests,
    emails,
    theme,
    camunda,
    jobs,
    admin,
    emailTemplates,
    packages
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
